import 'css-chunksrc/client/pages/personalSpacePage/timeSheet/loader/allocation/recordList/resourceTimeOverview/styles.scss';export default {
  "resourceTimeOverview": "_resourceTimeOverview_16qlr_1",
  "cell": "_cell_16qlr_8",
  "text": "_text_16qlr_18",
  "resource": "_resource_16qlr_1",
  "list": "_list_16qlr_27",
  "task": "_task_16qlr_31"
};